<template>
    <v-layout column wrap>
        <v-flex>
            <!--Allow Be in Confirmation Box -->
            <v-layout column wrap>
                <v-flex>
                    <v-alert 
                        v-if="!screener.allow_chat_room"
                        v-model="alert"
                        class="pa-2 mb-4"
                        color="primary"
                        icon="info"
                        outline
                        dismissible
                    >
                        {{ $t('screener_chat_room.chat_room_info_not_enabled') }}
                    </v-alert>
                    <v-alert 
                        v-else
                        v-model="alert"
                        class="pa-2 mb-4"
                        color="primary"
                        icon="info"
                        outline
                        dismissible
                    >
                        {{ $t('screener_chat_room.chat_room_info_enabled') }}
                    </v-alert>
                    <v-btn
                        v-if="!showBeInConfigurations"
                        class="ma-2"
                        :loading="loading2"
                        :disabled="loading2"
                        color="success"
                        @click="showConfirmationDialog"
                    >
                        {{ $t('enable.btn.title') }}
                    </v-btn>
                </v-flex>
                <ConfirmationDialogBox
                    :title="$t(`screener_chat_room.chat_room_confirmation_title`)"
                    :dialog="showConfirmation"
                    :yesBtnText="$t(`screener_chat_room.chat_room_confirmation_yes_btn_text`)"
                    :noBtnText="$t(`screener_chat_room.chat_room_confirmation_deny_btn_text`)"
                    @confirm="handleConfirmation()"
                    @cancel="handleCancellation()"
                    >
                    <p>{{ $t(`screener_chat_room.chat_room_confirmation_message`) }}</p>
                </ConfirmationDialogBox>
            </v-layout>
            <v-layout column wrap v-if="showBeInConfigurations">
                <div class="my-2">
                    <v-btn
                    color="error"
                    dark
                    large
                    @click="disableChatroom"
                    >
                        {{ $t('disable.btn.title') }}
                    </v-btn>
                    <v-btn
                        color="warning"
                        dark
                        large
                        @click="showConfigurationDialog = true"
                    >
                        <v-icon left>
                            mdi-wrench
                        </v-icon>
                        {{ $t('screener_chat_room.chat_room_configurations_btn_title') }}
                    </v-btn>
                </div>
                <ChatRoomConfiguartionDialog 
                    :screener="screener"
                    :handleDialogBox="showConfigurationDialog" 
                    @handleClose="closeConfigurationBox"
                />
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import DEFINES from "@/defines";
import ConfirmationDialogBox from "@/components/dialogBox/DynamicConfirmationBox";
import ChatRoomConfiguartionDialog from "@/components/screener/chatRoom/ChatRoomConfiguartionDialog";

export default {
    name: 'BeInConfiguration',
    components: {
        ConfirmationDialogBox,
        ChatRoomConfiguartionDialog
    },
    props: {
        screener: {
            type: Object,
        },
        eventPrefix: {
            type: String,
            default: "screener",
        },  
    },
    watch: {
        screener: {
            handler(newData) {
                this.showBeInConfigurations = (newData.allow_chat_room) ? true :false
                this.$emit("update:screener", this.screener);
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            alert: true,
            allow_chat_room:false,
            showConfirmation: false,
            showBeInConfigurations: false,
            showConfigurationDialog:false
        }
    },
    methods: {
        showConfirmationDialog() {
            this.screener.allow_chat_room = true
            this.showConfirmation = true
        },
        async handleConfirmation() {
            this.handleChatroom({
                screener_id: this.screener.id,
                allow_chat_room:true,
                max_members:DEFINES.CHAT_ROOM.DEFAULT_PARTICIPANTS
            });
        },
        async handleChatroom(payload) {
            let self = this
            await this.$store
                .dispatch("screener/updateScreenerChatroom",payload)
                .then((res) => {
                    self.screener.chat_room = res.chatRoom;
                    self.showConfirmation = false;
                    self.showBeInConfigurations = true
                })
                .catch((error) => {
                    this.$store.dispatch("app/showMessage", {
                        message: error.message,
                        color: "error",
                    });
                });
            
        },
        async disableChatroom() {
            this.handleChatroom({
                screener_id: this.screener.id,
                allow_chat_room:false
            });
            this.screener.allow_chat_room = false
        },
        handleCancellation() {
            this.screener.allow_chat_room = false
            this.showConfirmation=false
        },
        closeConfigurationBox() {
            this.showConfigurationDialog = false
        }
    }        
}
</script>
